<section class="section-div">
  <div class="content-details">
    <div class="title-details">
      <div class="d-flex">
        <h4><ion-icon name="calendar-outline"></ion-icon> Initiatives</h4>
        <div class="ml-auto">
          <button
            mat-raised-button
            color="primary"
            (click)="initiveAddBtn('Add')"
          >
            Add Initiatives
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="noData == false">
      <div class="example-container mat-elevation-z8">
        <mat-table #table [dataSource]="dataSource" [class.isMobile]="isMobile">
          <ng-container matColumnDef="index">
            <mat-header-cell *matHeaderCellDef class="table-no">
              No.
            </mat-header-cell>
            <mat-cell *matCellDef="let element; let i = index" class="table-no">
              <span class="mobile-label">No :</span>
              {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef class=""> Title</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label">Title:</span>
              <span class="">{{ element.title }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="menuOrder">
            <mat-header-cell *matHeaderCellDef class="ml-lg-2"
              >Menu Order</mat-header-cell
            >
            <mat-cell *matCellDef="let element">
              <span class="mobile-label"> Menu Order:</span>
              <span class="ml-lg-4">{{ element.menuOrder }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="showInMenu">
            <mat-header-cell *matHeaderCellDef>Show in Menu</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label">Show in Menu:</span>
              <ng-container *ngIf="element.showInMenu; else noDisplay">
                <button class="yesbtn ml-lg-1">Yes</button>
              </ng-container>
              <ng-template #noDisplay>
                <button class="nobtn ml-lg-1">No</button>
              </ng-template>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef> Action</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label"> Action:</span>
              <span
                ><img
                  class="newview-doc"
                  (click)="incubateeEvent(element.id)"
                  roleValue="Incubator"
                  [ngClass]="{ 'd-none': roleValue == 'Admin' }"
                  src="assets/images/viewdocument.png"
                  alt=""
              /></span>
              <mat-icon
                class="edit-i mr-lg-1"
                (click)="editInitiatives('Update', element.id)"
                [ngClass]="{ 'd-none': roleValue == 'Incubator' }"
              >
                edit</mat-icon
              >
              <mat-icon
                class="delete-i"
                (click)="deleteInitiatives(element.id)"
                [ngClass]="{ 'd-none': roleValue == 'Incubator' }"
              >
                delete</mat-icon
              >
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
      <mat-paginator
        [ngClass]="{ 'd-none': roleValue == 'Incubator' }"
        #paginator
        class="mat-elevation-z8"
        [length]="pageTotalCount"
        [pageSize]="pageSize"
        [pageSizeOptions]="[25, 50, 75, 100]"
        showFirstLastButtons
        (page)="getServerData($event)"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </div>
    <div class="text-center no-data-div" *ngIf="noData == true">
      <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
      <h6>No Records Found</h6>
    </div>
  </div>
</section>
